var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-progress",class:{
    theme: _vm.theme,
  },style:({
    '--size': _vm.size,
  })},[_c('div',{staticClass:"circle-clone"}),_c('div',{ref:"circle",staticClass:"circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }